// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"794":"conversation","962":"home"}[chunkId] + "." + {"794":"1577c57f","962":"b91de0d4"}[chunkId] + ".css";
};